// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"481d6dab","114":"f0ecb93e","256":"1e2681da","495":"7cedb9a6","563":"2c3769bf","568":"ef36c6ac","611":"87b9dad5","662":"1854e94c"}[chunkId] + ".chunk.js";
};